module.exports = __webpack_public_path__ + "img/notificationIcon.old.02492a2f.svg";